import { Text } from 'slate';
const defaultIsInline = () => false;
/**
 * Convert all child nodes under the given block or inline to BlockTexts
 * * to represent an entire text, which is concatenation of the all the texts.
 * * to translate the "parent" level offsets measured in the "entire text" above to the leaf level offsets.
 */
export const createBlockTexts = (node, isInline = defaultIsInline) => {
    const offsetMap = []; // This will be mutated!
    const lineMap = []; // This will be mutated!
    let textInBlock = '';
    const blockTexts = []; // `blockTexts` will be mutated!
    let offset = 0;
    const visitNode = (node, path) => {
        if (Text.isText(node)) {
            const startOffset = offset;
            const endOffset = startOffset + node.text.length;
            offsetMap.push({
                startOffset,
                endOffset,
                path: path,
            });
            textInBlock += node.text;
            offset = endOffset;
        }
        else {
            node.children.forEach((child, i) => {
                visitNode(child, path.concat(i));
                if (!isInline(node) &&
                    Text.isText(child) &&
                    i === node.children.length - 1) {
                    // If `child` is the last child of the parent block, it is considered there is a line break.
                    blockTexts.push(textInBlock);
                    lineMap.push(path);
                    offset += 1;
                    textInBlock = '';
                }
            });
        }
    };
    visitNode(node, []);
    const entireText = blockTexts.join('\n');
    return {
        entireText,
        offsetMap,
        lineMap,
    };
};
export const mapOffset = (blockTexts, globalOffset) => {
    let i = 0;
    for (const { startOffset, endOffset, path } of blockTexts.offsetMap) {
        if (globalOffset === endOffset) {
            // If the offset is just the boundary, choose the deeper node.
            const next = blockTexts.offsetMap[i + 1];
            if (next && next.path.length > path.length) {
                return {
                    path: next.path,
                    offset: globalOffset - next.startOffset,
                };
            }
            else {
                return {
                    path,
                    offset: globalOffset - startOffset,
                };
            }
        }
        else if (startOffset <= globalOffset && globalOffset < endOffset) {
            return {
                path,
                offset: globalOffset - startOffset,
            };
        }
        ++i;
    }
    return null;
};
export const mapLine = (blockTexts, globalLine) => {
    return blockTexts.lineMap[globalLine];
};
//# sourceMappingURL=index.js.map